module.exports = __webpack_public_path__ + "static/media/AjusteEstoque4.4ad9db7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancAjusteEstoque/AjusteEstoque4.png
// module id = 2051
// module chunks = 0